import { ProviderSearchResults } from '@/types'
export function providerSearchResultsFactory(res): ProviderSearchResults {
return res
}
